import { nanoid } from 'nanoid';

import {
  CategoryOption,
  InteractiveResponseCategoriesCategory,
  InteractiveResponseCategoriseItem,
} from '../interactive-response-categorise.constants';
import { ASSESSMENT_ACTIVITIES } from 'global/constants';

export function addCategory(value: string, existingValues: CategoryOption[]) {
  existingValues.push({
    label: value,
    value: nanoid(),
  });
  return existingValues;
}

export function getCategoryFromOption(
  options: CategoryOption[]
): InteractiveResponseCategoriesCategory[] {
  return options.map(o => ({
    id: o.value,
    label: o.label,
    __typename: 'CategoriseResponseCategory',
  }));
}

export function adjustItemsForRemovedCategory(
  previousCategories: InteractiveResponseCategoriesCategory[],
  newCategories: CategoryOption[],
  items: InteractiveResponseCategoriseItem[]
) {
  const removedItem = previousCategories.filter(
    item => !newCategories.find(v => v.value === item.id)
  );

  if (removedItem) {
    return items.map(item => {
      if (item.categoryId === removedItem[0].id) {
        return {
          ...item,
          categoryId: newCategories?.[0]?.value || null,
        };
      }
      return item;
    });
  }

  return items;
}

export function getShouldShowNumberOfItemsHint(
  showNumberOfItemsHint: boolean | null,
  contentType?: string
) {
  // Hide in assessments
  if (contentType === ASSESSMENT_ACTIVITIES) {
    return false;
  }
  return showNumberOfItemsHint === null ? true : !!showNumberOfItemsHint;
}
